import safeFetch from '../utils/safeFetch';

const submitRFQForm = (url, requestData) => {
  return new Promise((resolve, reject) => {
    safeFetch(url, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestData),
    })
      .then(async (response) => {
        const data = await response.json();

        // Statt nur data → alles zurückgeben:
        resolve({
          status: response.status,
          ok: response.ok,
          data: data,
        });
      })
      .catch((error) => reject(error));
  });
};

export default submitRFQForm;
